import FormItem from 'components/shared/BWFormControl/FormItem';
import FormSelect from 'components/shared/Select/FormSelect';
import FormTreeSelect from 'components/shared/Select/FormTreeSelect';
import { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { getOptionsComponentGroup } from 'services/component.service';
import { getOptionsTreeview } from 'services/product-category.service';
import { mapDataOptions4Select } from 'utils/helpers';

const FilterModel = ({ loadData }) => {
  const { register, control, reset, handleSubmit } = useForm();
  const [optionsCategory, setOptionsCategory] = useState([]);
  const [optionsComponentGroup, setOptionsComponentGroupp] = useState([]);

  const fetchOptionsComponentGroup = async (params = {}) => {
    try {
      const data = await getOptionsComponentGroup({ ...params });
      setOptionsComponentGroupp(mapDataOptions4Select(data));
    } catch (error) {
      console.log({ error });
    }
  };

  const fetchOptionsCategory = async (params = {}) => {
    try {
      const data = await getOptionsTreeview({ ...params });
      setOptionsCategory(data);
    } catch (error) {
      console.log({ error });
    }
  };

  const onLoadCategory = ({ id: parent_id }) =>
    new Promise((resolve, reject) => {
      const timeoutId = setTimeout(async () => {
        try {
          const data = await getOptionsTreeview({ parent_id });
          setOptionsCategory((prevOptions) => [...prevOptions, ...data]);
          resolve(undefined);
        } catch (error) {
          reject({ error });
        } finally {
          clearTimeout(timeoutId);
        }
      }, 300);
    });

  useEffect(() => {
    fetchOptionsCategory({ parent_id: 0 });
    fetchOptionsComponentGroup();
  }, []);

  const productType = [
    { value: 3, label: 'Tất cả' },
    { value: 1, label: 'Sản phẩm' },
    { value: 2, label: 'Linh kiện' },
  ];

  const onClear = () => {
    reset();
    loadData();
  };

  const onSubmit = () => {
    handleSubmit((data) => {
      loadData(data);
    })();
  };

  return (
    // <form>
    <div className='bw_search_box bw_col_12'>
      <div className='bw_row'>
        <FormItem label='Từ khoá' className='bw_col_4'>
          <input {...register('search')} type='text' placeholder='Nhập tên sản phẩm/linh kiện, mã sản phẩm/linh kiện' />
        </FormItem>
        <FormItem label='Loại hàng' className='bw_col_4'>
          <Controller
            control={control}
            name='product_type_id'
            render={({ field }) => (
              <FormSelect {...field} bordered={false} allowClear placeholder='-- Chọn --' options={productType} />
            )}
          />
        </FormItem>
        <FormItem label='Ngành hàng' className='bw_col_4'>
          <Controller
            control={control}
            name='product_category_id'
            render={({ field }) => (
              <FormTreeSelect
                {...field}
                bordered={false}
                treeData={optionsCategory}
                placeholder='-- Chọn --'
                allowClear
                treeDataSimpleMode
                loadData={onLoadCategory}
              />
            )}
          />
        </FormItem>
        <FormItem label='Nhóm linh kiện' className='bw_col_4'>
          <Controller
            control={control}
            name='component_group_id'
            render={({ field }) => (
              <FormSelect
                {...field}
                bordered={false}
                allowClear
                placeholder='-- Chọn --'
                options={optionsComponentGroup}
              />
            )}
          />
        </FormItem>
      </div>

      <div className='bw_row bw_align_items_center '>
        <div className='bw_col_12 bw_flex bw_justify_content_right bw_btn_group'>
          <button type='button' style={{ marginRight: '10px' }} onClick={onSubmit} className='bw_btn bw_btn_success'>
            <span className='fi fi-rr-filter' /> Tìm kiếm
          </button>
          <button type='button' onClick={onClear} className='bw_btn_outline'>
            Làm mới
          </button>
        </div>
      </div>
    </div>
    // </form>
  );
};

export default FilterModel;
